<template>
    <div id="materReceiveManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.code" placeholder="配送编号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.shopOutName" placeholder="发货门店"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px"class="hewidth">
                <el-select filterable :filter-method="PinyinMatch" @change="changeCreateUserName" clearable v-model="searchForm.createUserName" placeholder="操作人">
                    <el-option v-for="(item,index) in operatorUserAllList"
                        :label="item.staffName"
                        :value="item.staffName"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width: 22%; margin-bottom:15px">
                <el-date-picker
                style="width: 100%"
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="width: 30%; margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
            </el-form-item>
            <!-- <el-form-item class="fr">
                <el-col style="text-align:right">
                    
                </el-col>
            </el-form-item> -->
        </el-form>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @row-click="goToDetail">
                    <el-table-column
                        align="center"
                        prop="code"
                        width="145"
                        label="物料配送编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="配送类型">
                        <template slot-scope="scope">
                            <span>配送收货</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="shopOutName"
                        label="发货门店">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="sum"
                        label="配送数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUserName"
                        label="发货人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                        <template slot-scope="scope">
<!--                            <span v-if="scope.row.status ==4 " type="info">已取消</span>-->
<!--                            <span v-else-if="scope.row.status ==1 ">在库</span>-->
<!--                            <span v-else-if="scope.row.status ==2 " type="primary">已发货</span>-->
<!--                            <span v-else type="success">已收货</span>-->
                                <el-tag v-if="scope.row.status ==4 " type="info">已取消</el-tag>
                                <el-tag v-else-if="scope.row.status ==1 ">在库</el-tag>
                                <el-tag v-else-if="scope.row.status ==2 " type="primary">已发货</el-tag>
                                <el-tag v-else type="success">已收货</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUserName"
                        label="创建人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        width="155"
                        label="提交时间">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import {
        selectDistributionList,
        queryUser
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest';
    import PinyinMatch from 'pinyin-match';
    export default {
        name: 'materReceiveManage',
        components: {
        },
        data () {
            return {
                choose:{},
                deptId:'',  //门店类型
                valueTime3:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    attribute1:'',       // 创建时间（起）
                    attribute2:'',       //创建时间（止）
                    code: '',            //编号
                    shopOutName:'',      //发货门店
                    createUserName: '',  //创建人
                    addCode:""    //、添加小码
                },
                returnData: [],
                copy:[],
                operatorUserAllList:[],
                basicsAuth:{
                    insertDistribution:false
                }
            }
        },
        mounted () {
            this.basicsAuth.insertDistribution = getPermission("/api/distribution/insertDistribution")
        },
        created:function(){
            this.$destroy();
            this.deptId = JSON.parse(localStorage.getItem('userInfo')).deptId
            this.selectDistributionListShopInput();
            this.getOperatorUserAllList();
        },
        methods: {
            //强制刷新
            changeCreateUserName(e){
                console.log(e);
                this.searchForm.createUserName= e;
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.staffName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.createUserName = val;
                    this.operatorUserAllList = result;
                }else{
                    this.operatorUserAllList = this.copy;
                    this.searchForm.createUserName = "";
                }
            },
            clearFrom(){
                this.searchForm = {};
                this.valueTime3 = []
            },
            getOperatorUserAllList(){
                queryUser({type:2}).then(res => {
                    if (res.data.status==100) {
                        this.operatorUserAllList = res.data.results;
                        this.copy = Object.assign(this.operatorUserAllList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取物料配送收货管理列表
            selectDistributionListShopInput(){
                let para={
                    type:2,       //配送类型 1:配送发货&2:配送收货
                    attribute1:this.searchForm.attribute1,         //创建时间（起）
                    attribute2:this.searchForm.attribute2,         //创建时间（止）
                    code: this.searchForm.code,                    //编号
                    shopOutName:this.searchForm.shopOutName,       //发货门店
                    createUserName: this.searchForm.createUserName, //创建人
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize,
                }
                selectDistributionList(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.returnData.forEach((item,index)=>{
                            item.createTime = this.filters.formatDate(item.createTime)
                        })
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.selectDistributionListShopInput()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.selectDistributionListShopInput()
            },
            // 进入详情页面
            goToDetail(row) {
                this.$router.push({
                    path:'/materDeliveryInfo',
                    query:{
                        orderId:row.code
                    }
                })
            },
            //新建采购订单
            createOrder() {
                this.$router.push({
                    path:'/newMaterDelivery'
                })
            },
            refresh() {
                this.searchForm = {};
                this.valueTime3 = [];
                this.selectDistributionListShopInput();
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                if (valid) {
                if (!this.valueTime3) {
                    this.searchForm.attribute1 = ''
                    this.searchForm.attribute2 = ''
                }else if(this.valueTime3.length == 0){
                    this.searchForm.attribute1 = ''
                    this.searchForm.attribute2 = ''
                }else{
                    this.searchForm.attribute1 = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                    this.searchForm.attribute2 = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                }
                    this.selectDistributionListShopInput()

                } else {
                    console.log('验证未通过');
                    return false;
                }
            });
        }
    },
    computed: {
    },
    watch: {
    }
}
</script>

<style type="text/css" lang="scss" scoped>
    #materReceiveManage{
        font-size: 14px;
        .headerT{
            margin:10px 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px;
        }
    }
    .hewidth {
        width: 13% !important;
      }
</style>



// WEBPACK FOOTER //
// materReceiveManage.vue?5bb322e8